export default __webpack_public_path__ + "static/media/heartSearch.83eb7481.svg";